/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable max-lines */
import {
  Grid,
  Box as MuiBox,
  Button as MuiButton,
  Typography,
} from '@mui/material';
import moment from 'moment';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ComplianceCard from 'src/components/Compliance/ComplianceCard';
import RectangleBox from 'src/components/Compliance/RectangleBox';
import { UpdateApplication, UpdateApplicationRoute } from 'src/redux/actions/Application';
import { Store } from 'src/types';
import notcompliant from '../../assets/images/GreenStairs.png';
import RedExclamationMark from '../../assets/images/RedExclamationMark.png';
import CheckCircle from '../../assets/images/check_circle_24px.svg';
import ErrorCircle from '../../assets/images/error_24px.svg';

type Error = {
  message: string;
  type: string;
};

const checkOrErrorIcon = (isError: boolean) => {
  return isError ?
    <img src={ErrorCircle} height="30px" width="30px" alt="ErrorCircle" />
    :
    <img src={CheckCircle} height="30px" width="30px" alt="CheckCircle" />
}

const DatesText = ({
  covieData,
  outdated,
}: {
  covieData: Store['application']['covieData'];
  outdated: boolean;
}) => {
  const policyDates = covieData
    ? moment(covieData.inception_date).format('MM/DD/YYYY')
    : null;
  const PolicyDatesText = policyDates
    ? `Your policy starts ${moment(covieData.inception_date).format(
        'MM/DD/YYYY',
      )}`
    : '';
  return <>{outdated ? 'Policy dates outdated' : PolicyDatesText}</>;
};
const CoverageNotCompliant = ({ errors }: { errors: Error[] }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const errorMap: any = {};
  errors.map((error) => (errorMap[error.type] = error.message));
  const covieData = useSelector((store: Store) => store.application.covieData);
  const quote = useSelector((store: Store) => store.general.quote);
  const application = useSelector((store: Store) => store.application);

  const fillData = () => {
    dispatch(UpdateApplication({
      ...application.data,
      ...quote,
      firstName: quote.given_name,
      lastName: quote.family_name,
    }));
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
    });
  }, []);
  if (errorMap['Error']) {
    return <div>Policy Not found</div>;
  }
  const activePolicyError =
    errorMap['POLICY_DATES_INVALID'] || errorMap['ACTIVE_POLICY'];
  return (
    <>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        spacing={6}
        padding={5}
        marginTop={5}
        textAlign="center"
        // flexDirection="column"
      >
        <Grid item xs={12} md={9} lg={7}>
          <MuiBox display="flex" justifyContent="center" marginBottom={3}>
            <img className="image" src={RedExclamationMark} alt="" width="50px" height="50px" style={{ display: 'block' }}/>
          </MuiBox>
          <Typography
            variant="h2"
            fontFamily="Ivar Display"
          >
            Your coverage is not compliant.
          </Typography>
          <Typography variant="body1">
            We've reviewed your policy from {covieData?.carrier?.name || 'MSI'}{' '}
            and found that it's not compliant with the required coverage for
            your building.
          </Typography>
        </Grid>
        <Grid item xs={12} md={9} lg={7}>
          <img src={notcompliant} alt="" width="100%" height="100%" style={{ display: 'block', backgroundColor:'white' }}/>
        </Grid>
        <Grid item xs={12} md={9} lg={7}display="flex" justifyContent="center">
            <MuiButton
              variant="contained"
              onClick={() => history.goBack()}
            >
              Go Back
            </MuiButton>
        </Grid>
        <Grid item xs={12} md={9} lg={7}>
          <Grid container flexDirection="column" gap={3}>
            <RectangleBox
              statusIcon={
                checkOrErrorIcon(activePolicyError)
              }
              propertyName="Active Policy"
              propertyValue={
                <DatesText
                  covieData={covieData}
                  outdated={errorMap['POLICY_DATES_INVALID']}
                />
              }
            />
            <RectangleBox
              statusIcon={
                checkOrErrorIcon(
                  errorMap['ADDRESS_DOES_NOT_MATCH'] ||
                  errorMap['NAME_DOES_NOT_MATCH'] ||
                  errorMap['ADDRESS'])
              }
              propertyName="Address and Profile Details"
              propertyValue={
                errorMap['ADDRESS_DOES_NOT_MATCH'] ||
                errorMap['NAME_DOES_NOT_MATCH'] ||
                errorMap['ADDRESS'] ||
                'Your address is correct.'
              }
            />
            <RectangleBox
              statusIcon={
                checkOrErrorIcon(errorMap['PERSONAL_PROPERTY'])
              }
              propertyName="Personal Property Coverage"
              propertyValue={
                errorMap['PERSONAL_PROPERTY'] ||
                'Your coverage meets requirements.'
              }
            />
            <RectangleBox
              statusIcon={
                checkOrErrorIcon(errorMap['PERSONAL_LIABILITY'])
              }
              propertyName="Personal Liability Coverage"
              propertyValue={
                errorMap['PERSONAL_LIABILITY'] ||
                'Your coverage meets requirements.'
              }
            />
            <RectangleBox
              statusIcon={
                checkOrErrorIcon(errorMap['MEDICAL_PAYMENTS'])
              }
              propertyName="Medical Coverage"
              propertyValue={
                errorMap['MEDICAL_PAYMENTS'] ||
                'Your coverage meets requirements.'
              }
            />
          </Grid>
        </Grid>

        <Grid item xs={12} md={9} lg={7} marginTop={5}>
          <Grid container justifyContent="center" gap={4}>
            <Grid item>
              <Typography variant="h4">What can I do now?</Typography>
            </Grid>
            <Grid item>
              <Typography variant="h6">
                Here's what you can do to ensure you're compliant with your
                building's renter insurance requirment.
              </Typography>
            </Grid>

            <Grid item>
              <Grid container justifyContent="center" alignItems="stretch">
                <ComplianceCard
                  size="small"
                  bgColor="background.default"
                  onClick={() => {
                    fillData();
                    dispatch(UpdateApplicationRoute('/start-application'));
                    history.push({
                      pathname: '/start-application',
                      state: { detail: 'compliance' },
                    });
                  }}
                  title="Purchase a compliant plan."
                  mainText="Purchase a compliant plan through TheGuarantor’s renters insurance. We’ve pre-set the coverage to fit your landlord’s requirements."
                  linkText="Purchase a policy"
                />
                <ComplianceCard
                  size="small"
                  bgColor="background.secondary"
                  onClick={() => {}}
                  title="Contact your insurance provider."
                  mainText="Go back to your insurance provider and make the necessary changes mentioned above."
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default CoverageNotCompliant;
